package pt.at.oss.kotlin.manual.schema.nonunionform

import pt.at.oss.kotlin.manual.schema.common.AddressSchema
import pt.at.oss.kotlin.manual.schema.common.VatIdSchema
import pt.at.oss.kotlin.manual.schema.common.bankaccountinfo.BankAccountInfoSchema
import pt.at.oss.kotlin.manual.schema.common.contactinfo.ContactInfoSchema
import pt.at.oss.kotlin.manual.schema.common.contactname.ContactNameSchema
import pt.at.oss.kotlin.manual.schema.common.currvatid.CurrVatIdSchema
import pt.at.oss.kotlin.manual.schema.common.fixedestablishments.FixedEstablishmentsEntrySchema
import pt.at.oss.kotlin.manual.schema.common.relevantdates.RelevantDatesSchema
import pt.at.oss.kotlin.manual.schema.common.supplycommencement.SupplyCommencementSchema
import pt.at.oss.kotlin.manual.schema.common.tradingnames.TradingNamesEntrySchema
import pt.at.oss.kotlin.manual.schema.common.websites.WebsitesEntrySchema
import pt.at.oss.kotlin.manual.storage.common.VatId
import pt.at.oss.kotlin.manual.storage.common.fixedestablishments.FixedEstablishmentsEntry
import pt.at.oss.kotlin.manual.storage.common.tradingnames.TradingNamesEntry
import pt.at.oss.kotlin.manual.storage.common.websites.WebsitesEntry
import pt.at.oss.kotlin.manual.storage.nonunionform.NonUnionForm
import pt.lightweightform.kotlin.schema.BooleanSchema
import pt.lightweightform.kotlin.schema.ListSchema
import pt.lightweightform.kotlin.schema.RecordSchema
import pt.lightweightform.kotlin.schema.StringSchema
import pt.lightweightform.kotlin.type.validator.ValidationErrors
import pt.lightweightform.kotlin.util.appendToPath

/**
 * NonUnionFormSchema Schema object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
class NonUnionFormSchema : RecordSchema<NonUnionForm>(name = "non-union-form") {

    val issuingCountrySchema: StringSchema = StringSchema(name = "issuingCountry", minLength = 1)
    val nationaTaxNumberSchema: StringSchema = StringSchema(name = "nationaTaxNumber", minLength = 1)
    val currVatIdSchema: CurrVatIdSchema = CurrVatIdSchema()
    val actsAsElectronicInterfaceSchema: BooleanSchema = BooleanSchema(name = "actsAsElectronicInterface")
    val notEstablishedInEUSchema: BooleanSchema = BooleanSchema(name = "notEstablishedInEU")
    val bankAccountInfoSchema: BankAccountInfoSchema = BankAccountInfoSchema()
    var fixedEstablishmentsSchema: ListSchema<FixedEstablishmentsEntrySchema, FixedEstablishmentsEntry> =
        ListSchema(
            name = "fixedEstablishments",
            childRecordSchema = FixedEstablishmentsEntrySchema()
        )
    val companyNameSchema: StringSchema = StringSchema(name = "companyName", minLength = 1, maxLength = 160)
    var tradingNamesSchema: ListSchema<TradingNamesEntrySchema, TradingNamesEntry> =
        ListSchema(
            name = "tradingNames",
            childRecordSchema = TradingNamesEntrySchema()
        )
    val countryOfBusinessSchema: StringSchema = StringSchema(name = "countryOfBusiness", isRequired = true, minLength = 2, maxLength = 2)
    val cobRegionSchema: StringSchema = StringSchema(name = "cobRegion", isRequired = false, minLength = 2, maxLength = 2)
    val addressSchema: AddressSchema = AddressSchema()
    var websitesSchema: ListSchema<WebsitesEntrySchema, WebsitesEntry> =
        ListSchema(
            name = "websites",
            childRecordSchema = WebsitesEntrySchema()
        )
    val contactNameSchema: ContactNameSchema = ContactNameSchema()
    val contactInfoSchema: ContactInfoSchema = ContactInfoSchema()
    var prevOrCurrOssVatIdSchema: ListSchema<VatIdSchema, VatId> =
        ListSchema(
            name = "prevOrCurrOssVatId",
            childRecordSchema = VatIdSchema(name = "prevOrCurrOssVatId", isRequired = true)
        )
    val supplyCommencementSchema: SupplyCommencementSchema = SupplyCommencementSchema()
    val relevantDatesSchema: RelevantDatesSchema = RelevantDatesSchema()
    override fun isValid(value: NonUnionForm?): Boolean {
        return value == null || (
            nationaTaxNumberSchema.isValid(value.nationalTaxNumber) &&
                issuingCountrySchema.isValid(value.issuingCountry) &&
                currVatIdSchema.isValid(value.currVatId) &&
                notEstablishedInEUSchema.isValid(value.notEstablishedInEU) &&
                bankAccountInfoSchema.isValid(value.bankAccountInfo) &&
                companyNameSchema.isValid(value.companyName) &&
                tradingNamesSchema.isValid(value.tradingNames) &&
                countryOfBusinessSchema.isValid(value.countryOfBusiness) &&
                cobRegionSchema.isValid(value.cobRegion) &&
                addressSchema.isValid(value.address) &&
                websitesSchema.isValid(value.websites) &&
                contactNameSchema.isValid(value.contactName) &&
                contactInfoSchema.isValid(value.contactInfo) &&
                prevOrCurrOssVatIdSchema.isValid(value.prevOrCurrOssVatId) &&
                supplyCommencementSchema.isValid(value.supplyCommencement) &&
                relevantDatesSchema.isValid(value.relevantDates)
            )
    }

    override fun validate(value: NonUnionForm?, path: String): ValidationErrors {
        val validator = super.validate(value, path)
        if (value === null) {
            return validator
        }
        validator.addErrors(issuingCountrySchema.validate(value.issuingCountry, appendToPath(path, "issuingCountry")))
        validator.addErrors(nationaTaxNumberSchema.validate(value.nationalTaxNumber, appendToPath(path, "nationalTaxNumber")))
        validator.addErrors(notEstablishedInEUSchema.validate(value.notEstablishedInEU, appendToPath(path, "notEstablishedInEU")))
        validator.addErrors(currVatIdSchema.validate(value.currVatId, appendToPath(path, "currVatId")))
        validator.addErrors(bankAccountInfoSchema.validate(value.bankAccountInfo, appendToPath(path, "bankAccountInfo")))
        validator.addErrors(companyNameSchema.validate(value.companyName, appendToPath(path, "companyName")))

        validator.addErrors(tradingNamesSchema.validate(value.tradingNames, appendToPath(path, "tradingNames")))

        validator.addErrors(countryOfBusinessSchema.validate(value.countryOfBusiness, appendToPath(path, "countryOfBusiness")))
        validator.addErrors(cobRegionSchema.validate(value.cobRegion, appendToPath(path, "cobRegion")))
        validator.addErrors(addressSchema.validate(value.address, appendToPath(path, "address")))

        validator.addErrors(websitesSchema.validate(value.websites, appendToPath(path, "websites")))
        validator.addErrors(contactNameSchema.validate(value.contactName, appendToPath(path, "contactName")))
        validator.addErrors(contactInfoSchema.validate(value.contactInfo, appendToPath(path, "contactInfo")))

        validator.addErrors(prevOrCurrOssVatIdSchema.validate(value.prevOrCurrOssVatId, appendToPath(path, "prevOrCurrOssVatId")))

        validator.addErrors(supplyCommencementSchema.validate(value.supplyCommencement, appendToPath(path, "supplyCommencement")))
        validator.addErrors(relevantDatesSchema.validate(value.relevantDates, appendToPath(path, "relevantDates")))
        return validator
    }
}
